import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import RiverCanvas from '../components/interactives/River/RiverCanvas';
import Tremor from '../components/interactives/Tremor/TremorCanvas';
import CrumpleCanvas from '../components/interactives/Crumple/CrumpleCanvas';
import SensationsCanvas from '../components/interactives/Sensations/SensationsCanvas';
import MeltCanvas from '../components/interactives/Melt/MeltCanvas';
import Radio from '../components/interactives/Radio';
import Tangle from '../components/interactives/Tangle';
import Smoke from '../components/interactives/Smoke';
import Gum from '../components/interactives/Gum';
import SnakeCanvas from '../components/interactives/Snake/SnakeCanvas';
import DriftCanvas from '../components/interactives/Drift/DriftCanvas';
import TextFX from 'txt-fx';



const NestedSummaryDetails = ({ data }) => {
 
    return (
            <ul style={{
                listStyle: 'none',
                fontSize: '2.5rem',
                fontFamily: 'sans-serif',
            }}>
            {data.map((item, index) => (
                <li key={index}>
                {typeof item === 'string' ? (
                    item
                ) : (
                    <>
                    <details>
                        <summary style={{
                        }}>{item.summary}</summary>
                        <NestedSummaryDetails data={item.details} />
                    </details>
                    </>
                )}
                </li>
            ))}
            </ul>
    );
};

const Story = ({story}) => {
    const { title, interactive, year } = story;

    useEffect(() => {
        const title = document.querySelector('#title');
        const subtitle = document.querySelector('#subtitle');
        const textFX = new TextFX.Scrambler();
        textFX.scramble(title, 100, 10, true);
        textFX.scramble(subtitle, 100, 10, true);
    }, []);

    const Art = ({interactive}) => {
        switch(interactive) {
            case 'river':
                return <RiverCanvas/>;
            case 'tremor':
                return <Tremor/>;
            case 'crumple':
                return <CrumpleCanvas/>;
            case 'sensations':
                return <SensationsCanvas/>;
            case 'melt':
                return <MeltCanvas/>;
            case 'radio':
                return <Radio/>;
            case 'tangle':
                return <Tangle/>;
            case 'smoke':
                return <Smoke/>;
            case 'gum':
                return <Gum/>;
            case 'snake':
                return <SnakeCanvas/>;
            case 'drift':
                return <DriftCanvas/>;
            default:
                return null;
        }
    }

    return (
        <article style={{
            margin: 'auto',
        }}>
            <div style={{
                height: '100vh',
            }}>
                <Link to="/">&lt;</Link>
                <hr/>
                <h1 id="title">{title}</h1>
                <p id="subtitle">{year}</p>
                <Art interactive={interactive}/>
            </div>
        </article>
    );
};

export default Story;
